import FastClick from './vendor/fastclick';

document.addEventListener('DOMContentLoaded', function () {
  FastClick.attach(document.body);
});
